export const config = {
  api: {
    url: process.env.REACT_APP_API_URL || 'https://ucsd-backend.herokuapp.com'
  }
}